import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type StorePickerFilterComponentProps = {
    storeFeature: string;
    active: boolean;
    onToggle: (filter: string) => void;
};

const StorePickerFilterComponent = ({
    storeFeature,
    active,
    onToggle,
}: StorePickerFilterComponentProps) => {
    const { t } = useGranite();

    const handleOnChange = () => onToggle(storeFeature);

    return (
        <li className={"store-picker-filters__filters__filter"}>
            <input
                className={"ml-1"}
                id={`storePickerFilter--${storeFeature}`}
                type="checkbox"
                checked={active}
                onChange={handleOnChange}
            />
            <label
                className={"m-0"}
                htmlFor={`storePickerFilter--${storeFeature}`}
            >
                {t(`form.searchstore.filter.${storeFeature}`)}
            </label>
        </li>
    );
};

export { StorePickerFilterComponent };
